


















import { Component, Prop, Vue } from 'vue-property-decorator';
import metadata from '@/store/modules/metadata';

@Component({
  components: {},
})
export default class Modal extends Vue {
  reason = '';

  confirm() {
    this.$emit('confirm', this.reason);
  }

  cancel() {
    this.$emit('cancel');
  }
}
